import { Set, List } from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { SubmittalQuery } from 'records/SubmittalQuery';
import querySubmittals from 'utils/querySubmittals';

export interface SubmittalQueryActions {
  setSubmittalQuery: (
    actionParams: AppStateActionParams,
    nextSubmittalQuery: SubmittalQuery
  ) => AppState;

  querySubmittals: (actionParams: AppStateActionParams) => AppState;
  initSubmittalQuery: (actionParams: AppStateActionParams) => AppState;
}

const submittalQueryActions: SubmittalQueryActions = {
  setSubmittalQuery: (
    { state }: AppStateActionParams,
    nextSubmittalQuery: SubmittalQuery
  ): AppState => {
    const { submittals } = state();

    const qSubmittals = querySubmittals(submittals, nextSubmittalQuery)
      .keySeq()
      .toList();
    return state()
      .set('submittalQuery', nextSubmittalQuery)
      .set('queriedSubmittals', qSubmittals);
  },

  querySubmittals: ({ state }: AppStateActionParams): AppState => {
    const { submittals, submittalQuery } = state();
    const qSubmittals = querySubmittals(submittals, submittalQuery);
    const queriedSubmittals = List(qSubmittals.keys());
    return state().set('queriedSubmittals', queriedSubmittals);
  },

  initSubmittalQuery: ({ state }: AppStateActionParams): AppState => {
    const { submittals, submittalQuery } = state();

    const qSubmittals = querySubmittals(submittals, submittalQuery);

    return state()
      .set('submittalQuery', submittalQuery)
      .set('queriedSubmittals', List(qSubmittals.keys()));
  },
};

export default submittalQueryActions;
